export default Object.freeze({
  TEAM_CHAT_CHANNEL: 'chat_team_messages',
  CHAT_CHANNEL: 'chat_public_messages',
  POLL_CHANNEL: 'poll',
  POLL_ANSWER_CHANNEL: 'poll_answer',
  POLL_ANSWER_USER_CHANNEL: 'poll_answer_user',
  DOCUMENTS_CHANNEL: 'documents'
})
